import { initialState as initialGroupsState } from './Groups/constants';

export const initialState = {
    groups: {...initialGroupsState},
};